// Authentication provider component

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '@/app/store';
import { getCurrentUser } from '@/app/slices/authSlice';
import { TokenManager } from '@/utils/api';
import { Box, CircularProgress } from '@mui/material';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const [initializing, setInitializing] = React.useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      const accessToken = TokenManager.getAccessToken();
      const refreshToken = TokenManager.getRefreshToken();

      if (accessToken && refreshToken && !isAuthenticated) {
        try {
          await dispatch(getCurrentUser()).unwrap();
        } catch (error) {
          // Token is invalid, clear it
          TokenManager.clearTokens();
        }
      }
      
      setInitializing(false);
    };

    initializeAuth();
  }, [dispatch, isAuthenticated]);

  // Gate ONLY on session initialization. auth.isLoading covers EVERY auth
  // request (login/logout/changePassword) — gating on it swapped the whole
  // tree for a spinner mid-login, unmounting the login page and destroying
  // its authenticating/error state before the user could see it.
  if (initializing) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        className="glass-effect"
      >
        <CircularProgress size={60} thickness={4} />
      </Box>
    );
  }

  return <>{children}</>;
};


















